import { Checkbox, Flex, Stack } from '@chakra-ui/react';
import { Cart } from '@diamond/shared/types';
import { Heading } from '@diamond/shared/ui';
import React, { useCallback, useMemo } from 'react';

export type CartDivisionSelectionState = {
  isChecked: boolean;
  isIndeterminate: boolean;
  isDisabled: boolean;
};

interface CartDivisionSectionProps {
  division: string;
  items: Cart[];
  children: React.ReactNode;
  selection?: CartDivisionSelectionState;
  onToggleDivision?: (division: string) => void;
}

export const CartDivisionSection = ({
  division,
  items,
  children,
  selection,
  onToggleDivision,
}: CartDivisionSectionProps) => {
  const divisionLabel = useMemo(
    () => (division === 'fnb' ? 'Fine Food' : division),
    [division]
  );

  const handleToggle = useCallback(() => {
    if (selection?.isDisabled) return;
    onToggleDivision?.(division);
  }, [onToggleDivision, division, selection]);

  if (items.length === 0) {
    return null;
  }

  return (
    <Stack>
      <Flex alignItems="center" gap="3" mt={6}>
        {selection ? (
          <Checkbox
            isChecked={selection.isChecked}
            isIndeterminate={selection.isIndeterminate}
            isDisabled={selection.isDisabled}
            colorScheme="blue"
            borderColor="#8E8E93"
            onChange={handleToggle}
            size={{ base: 'md', lg: 'lg' }}
          />
        ) : null}
        <Heading
          size="md"
          fontWeight="normal"
          textTransform="capitalize"
          fontSize={{ base: '18px', md: '20px' }}
        >
          {divisionLabel}
        </Heading>
      </Flex>
      {children}
    </Stack>
  );
};
